import { FOfferType, offerTypeFromJsonQuery } from '../../../common/packages/JsonQuery';
import { IJsonQuery } from '../../../common/packages/api-models/common/json_query';

export function isProPlus(jsonQuery: IJsonQuery) {
  const offerType = offerTypeFromJsonQuery(jsonQuery);

  // Новостройки + смешанная
  return (offerType & FOfferType.Flat) !== 0 && offerType !== FOfferType.FlatOld;
}
